// src/pages/Contact/Contact.js
import React from 'react';
import './Contact.css';
import EarlyAccessForm from '../../components/EarlyAccessForm/EarlyAccessForm';
import NewsletterSignup from '../../components/NewsletterSignup/NewsletterSignup';

const Contact = () => {
  const cofounders = [
    {
      name: "Kaitlyn Kumar",
      title: "Co-Founder, Head of Technology",
      email: "kaitlyn@pointesense.com",
    },
    {
      name: "Christine Fernandez",
      title: "Co-Founder, Head of Product",
      email: "christine@pointesense.com",
    }
  ];

  return (
    <div className="contact-container">
      <div className="contact-header">
        <h1 className="contact-page-heading">Contact Us</h1>
        <p className="contact-intro">
          Whether you want to be part of a beta testing study, explore a research or brand
          collaboration, are a potential customer curious about the product, or just want to stay
          in the loop, we&rsquo;d love to hear from you.
        </p>
      </div>

      {/* Contact options */}
      <div className="contact-options">
        <div className="contact-card">
          <h2>Join Our Mailing List</h2>
          <p>Get product updates, research notes, and news from PointeSense in your inbox.</p>
          <NewsletterSignup idPrefix="contact-newsletter" />
        </div>

        <div className="contact-card">
          <h2>Join Early Access</h2>
          <p>Be among the first to use PointeSense. Join our early access list for product updates, research notes, and invitations to beta test.</p>
          <EarlyAccessForm idPrefix="contact" />
        </div>

        <div className="contact-card">
          <h2>Email Us</h2>
          <p>Have questions or want to learn more about PointeSense? Send us an email and we'll get back to you as soon as possible.</p>
          <a href="mailto:hello@pointesense.com" className="email-link">
            <svg className="email-icon" viewBox="0 0 24 24" width="24" height="24">
              <path fill="currentColor" d="M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z"/>
            </svg>
            hello@pointesense.com
          </a>

          <p>For specific inquiries regarding our technology and collaborations, please use the following contact:</p>
          <a href="mailto:info@pointesense.com" className="email-link">
            <svg className="email-icon" viewBox="0 0 24 24" width="24" height="24">
              <path fill="currentColor" d="M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z"/>
            </svg>
            info@pointesense.com
          </a>

          <div className="contact-card-divider"></div>

          <h3 className="contact-card-subheading">Follow Us</h3>
          <div className="social-links">
            <a href="https://www.instagram.com/pointesense/" className="social-link" aria-label="Instagram">
              <svg viewBox="0 0 24 24" width="24" height="24">
                <path fill="currentColor" d="M7.8,2H16.2C19.4,2 22,4.6 22,7.8V16.2A5.8,5.8 0 0,1 16.2,22H7.8C4.6,22 2,19.4 2,16.2V7.8A5.8,5.8 0 0,1 7.8,2M7.6,4A3.6,3.6 0 0,0 4,7.6V16.4C4,18.39 5.61,20 7.6,20H16.4A3.6,3.6 0 0,0 20,16.4V7.6C20,5.61 18.39,4 16.4,4H7.6M17.25,5.5A1.25,1.25 0 0,1 18.5,6.75A1.25,1.25 0 0,1 17.25,8A1.25,1.25 0 0,1 16,6.75A1.25,1.25 0 0,1 17.25,5.5M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z"/>
              </svg>
            </a>
            <a href="https://www.linkedin.com/company/pointesense/" className="social-link linkedin-icon" aria-label="LinkedIn">
              <svg viewBox="0 0 24 24" width="24" height="24">
                <path fill="currentColor" d="M19 0H5C2.24 0 0 2.24 0 5v14c0 2.76 2.24 5 5 5h14c2.76 0 5-2.24 5-5V5c0-2.76-2.24-5-5-5zM7.5 20H4.5V9h3v11zm-1.5-13.26c-.97 0-1.74-.79-1.74-1.75C4.26 4.79 5.03 4 6 4c.97 0 1.74.79 1.74 1.75S6.97 6.74 6 6.74zm14.5 13.26h-3v-5.5c0-1.36-.03-3.12-1.9-3.12-1.91 0-2.2 1.49-2.2 3.03v5.59h-3v-11h3v1.5c.42-.81 1.44-1.5 2.86-1.5 3.08 0 3.65 2.03 3.65 4.69v6.31z"/>
              </svg>
            </a>
          </div>
        </div>

        <div className="contact-card">
          <h2>Join the Team</h2>
          <p>
            We&rsquo;re looking for founding members across product design, business, marketing,
            market research, software, hardware, and machine learning. Dance experience is
            welcome, but not required.
          </p>
          <p className="priority-note">
            Right now we especially need help with <strong>marketing &amp; social media</strong>,{' '}
            <strong>market research</strong>, and <strong>business</strong>.
          </p>
          <a
            href="mailto:hello@pointesense.com?subject=FOUNDING%20MEMBER&body=Tell%20us%20a%20bit%20about%20your%20experience%20and%20what%20draws%20you%20to%20PointeSense%3A"
            className="email-link"
          >
            <svg className="email-icon" viewBox="0 0 24 24" width="24" height="24">
              <path fill="currentColor" d="M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z"/>
            </svg>
            hello@pointesense.com
          </a>
          <p className="email-instructions">Include &ldquo;FOUNDING MEMBER&rdquo; in your subject line.</p>
        </div>
      </div>

      {/* Founders */}
      <div className="cofounders-section">
        <h2>Founders</h2>
        <div className="cofounder-cards">
          {cofounders.map((cofounder, index) => (
            <div key={index} className="cofounder-simple">
              <h3>{cofounder.name}</h3>
              <p className="cofounder-title">{cofounder.title}</p>
              <a href={`mailto:${cofounder.email}`} className="cofounder-email-link">
                {cofounder.email}
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Contact;
